import React from 'react';
import { lisActionInterface, paramActionsInterface } from '../../Objects/interfaces/AppInterface';
import { Button, ListItem, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { useTailwindBrand } from '../shared';

interface TdItem {
    title: any;
    classTrTd: string;
}

interface Props {
    id: number
    toggleRow: (index: number) => void
    activeRow: number | null
    datas: TdItem[]
    subDatas?: TdItem[]
    subtitle?: string
    bgCustom?: string
    colSpan?: number
    isCollapse: Boolean
    customTr?: Boolean
    contentRef?: any
    inputChild?: any
    subChild?: any
    paramActions?: paramActionsInterface
    hideParam?: boolean
}

const TableTbodyLayout = (props: Props) => {
    const { classes, brand } = useTailwindBrand();
    const [contextMenu, setContextMenu] = React.useState<{
        mouseX: number;
        mouseY: number;
    } | null>(null);
    const handleContextMenu = (event: React.MouseEvent) => {
        if (props.paramActions?.isOK) {
            event.preventDefault();

            setContextMenu(
                contextMenu === null
                    ? {
                        mouseX: event.clientX + 2,
                        mouseY: event.clientY - 6,
                    }
                    :
                    null,
            );

            // Prevent text selection lost after opening the context menu on Safari and Firefox
            const selection = document.getSelection();
            if (selection && selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);

                setTimeout(() => {
                    selection.addRange(range);
                });
            }
        }
    };
    const handleClose = () => {
        setContextMenu(null);
    };

    return (
        <>
            {props.customTr ?
                <>
                    <tr id="content" ref={props.contentRef} className={`'group/item  ${props.bgCustom ?? `${classes.backgroundHover} ${classes.text}`}  hover:rounded-xl hover:py-4 group/edit ${props.activeRow === props.id ? `${classes.background} shadow-md` : ''} `} onClick={() => props.toggleRow(props.id)}>
                        {props.datas.map((data: TdItem, index: number) => (
                            <td key={index} className={`${data.classTrTd} border-y ${classes.backgroundBorder} font-/semibold  whitespace-nowrap`}>
                                {data.title}
                            </td>
                        ))}
                    </tr>
                    {(props.isCollapse && props.activeRow === props.id) && (
                        <tr className="">
                            <td colSpan={props.colSpan} className={`border-2 ${classes.backgroundBorder} border-t-0 shadow-md rounded-b-md p-2`}>
                                <h4 className={`uppercase font-bold text-xs ${classes.text}`}>{props.subtitle}</h4>
                                <div className='flex items-center py-2'>
                                    {props.inputChild}
                                </div>
                            </td>
                        </tr>
                    )}
                </> :
                <>
                    <tr className={`border-b ${props.bgCustom ?? `${classes.backgroundHover} ${classes.text}`} ${props.activeRow === props.id ? `${classes.background} bg-opacity-40 shadow-md` : ''} `} onClick={() => props.toggleRow(props.id)}>
                        {props.datas.map((data: TdItem, index: number) => (
                            <td onClick={handleContextMenu} key={index} className={`${data.classTrTd} border-y ${classes.backgroundBorder} font-/semibold whitespace-nowrap cursor-pointer`}>
                                {data.title}
                                <Menu
                                    open={contextMenu !== null}
                                    onClose={handleClose}
                                    anchorReference="anchorPosition"
                                    anchorPosition={
                                        contextMenu !== null
                                            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                            : undefined
                                    }
                                    className={props.hideParam ? 'hidden' : ''}
                                >
                                    {props.paramActions?.listItems?.map((items: lisActionInterface, key: number) => (
                                        <MenuItem key={key} onClick={items.funct} className={`${items.class}`}>
                                            <ListItemIcon >{items.icon}</ListItemIcon>
                                            <ListItem className={`${classes.fontFamily}`}>{items.title}</ListItem>
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </td>
                        ))}
                    </tr>
                    {(props.isCollapse && props.activeRow === props.id) && (
                        <tr className="">
                            <td colSpan={props.colSpan} className="border-2 border-[#E9EFF4] border-t-0 shadow-md rounded-b-md p-2">
                                <h4 className='uppercase font-bold text-xs text-normal py-2'>{props.subtitle}</h4>
                                {props.subChild}
                                <div className='flex items-center'>
                                    {props?.subDatas?.map((data: TdItem, index: number) => (
                                        <div key={index} className={`grow ${data.classTrTd}`}>{data.title}</div>
                                    ))}
                                </div>
                            </td>
                        </tr>
                    )}
                </>

            }
        </>
    );
};

export default TableTbodyLayout;